import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { DecisionKind, Severity, SubmissionStatus } from '../types'

const statusMeta: Record<SubmissionStatus, { label: string; className: string }> = {
    draft: { label: 'Draft', className: 'border-border text-muted-foreground' },
    submitted: { label: 'Submitted', className: 'border-primary/40 text-primary' },
    in_review: { label: 'In review', className: 'border-amber-500/50 bg-amber-500/10 text-amber-700 dark:text-amber-400' },
    returned: { label: 'Sent back', className: 'border-orange-500/50 bg-orange-500/10 text-orange-700 dark:text-orange-400' },
    approved: { label: 'Approved', className: 'border-primary/50 bg-primary/10 text-primary' },
    refused: { label: 'Refused', className: 'border-destructive/50 bg-destructive/10 text-destructive' },
    withdrawn: { label: 'Withdrawn', className: 'border-border text-muted-foreground' },
}

export function StatusBadge({ status }: { status: SubmissionStatus }) {
    const m = statusMeta[status] ?? { label: status, className: '' }
    return <Badge variant="outline" className={cn('font-medium', m.className)}>{m.label}</Badge>
}

const severityClass: Record<Severity, string> = {
    high: 'border-destructive/50 bg-destructive/10 text-destructive',
    medium: 'border-amber-500/50 bg-amber-500/10 text-amber-700 dark:text-amber-400',
    low: 'border-primary/40 bg-primary/10 text-primary',
    info: 'border-border text-muted-foreground',
}

export function SeverityBadge({ severity }: { severity: Severity }) {
    return (
        <Badge variant="outline" className={cn('font-medium capitalize', severityClass[severity])}>
            {severity}
        </Badge>
    )
}

export const decisionLabels: Record<DecisionKind, string> = {
    accept: 'Approve',
    acknowledge: 'Acknowledge',
    approve_with_conditions: 'Approve with conditions',
    refuse: 'Refuse',
    send_back: 'Send back',
}

export function DecisionBadge({ decision }: { decision: DecisionKind }) {
    return (
        <Badge
            variant="outline"
            className={cn('text-[10px] font-medium', decision === 'refuse' ? 'border-destructive/50 text-destructive' : decision === 'send_back' ? 'border-orange-500/50 text-orange-700 dark:text-orange-400' : 'border-primary/50 text-primary')}
        >
            {decisionLabels[decision] ?? decision}
        </Badge>
    )
}
